/**
 * Count-up for the About page stats band (sections/stats-band.liquid).
 * Each [data-stat-value] animates from 0 to its number the first time the band is visible.
 * Text around the digits ("20+", "1000s") is preserved. Honors prefers-reduced-motion.
 */
class StatCounter extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;

    this.items = [...this.querySelectorAll('[data-stat-value]')].map((element) => {
      const text = element.textContent.trim();
      const match = text.match(/[\d,]*\.?\d+/);
      if (!match) return null;
      const number = match[0];
      return {
        element,
        text,
        prefix: text.slice(0, match.index),
        suffix: text.slice(match.index + number.length),
        target: parseFloat(number.replace(/,/g, '')),
        decimals: number.includes('.') ? number.split('.')[1].length : 0,
        grouped: number.includes(','),
      };
    }).filter(Boolean);

    this.items.forEach((item) => (item.element.textContent = this.format(item, 0)));

    this.observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      this.observer.disconnect();
      this.run();
    }, { threshold: 0.4 });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  format(item, value) {
    const digits = value.toLocaleString('en-US', {
      minimumFractionDigits: item.decimals,
      maximumFractionDigits: item.decimals,
      useGrouping: item.grouped,
    });
    return `${item.prefix}${digits}${item.suffix}`;
  }

  run() {
    const duration = 1400;
    const start = performance.now();
    const step = (now) => {
      const progress = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - progress, 3);
      this.items.forEach((item) => {
        item.element.textContent = progress < 1 ? this.format(item, item.target * eased) : item.text;
      });
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }
}
customElements.define('stat-counter', StatCounter);
